// Port of api/fuel/app/classes/insights/plays/calendar.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'calendar',
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''
        var calType = filter.calendar || 'days'

        var values, raw, i

        if (calType === 'days') {

            raw = Util.queryFast(
                'SELECT SUM(p.play_count) AS c,' +
                " strftime('%w', p.play_date, 'unixepoch') AS d" +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                sqlCount +
                " GROUP BY strftime('%w', p.play_date, 'unixepoch')"
            )

            values = [0, 0, 0, 0, 0, 0, 0]

            for (i = 0; i < raw.length; i++) {
                values[parseInt(raw[i].d, 10)] = parseInt(raw[i].c, 10)
            }

            // Shift Sunday from front to back (Mon-Sun order)
            var first = values.shift()
            values.push(first)

        } else if (calType === 'months') {

            raw = Util.queryFast(
                'SELECT SUM(p.play_count) AS c,' +
                " CAST(strftime('%m', p.play_date, 'unixepoch') AS INTEGER) AS d" +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                sqlCount +
                " GROUP BY CAST(strftime('%m', p.play_date, 'unixepoch') AS INTEGER)"
            )

            values = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

            for (i = 0; i < raw.length; i++) {
                values[parseInt(raw[i].d, 10) - 1] = parseInt(raw[i].c, 10)
            }

        } else if (calType === 'years') {

            raw = Util.queryFast(
                'SELECT SUM(p.play_count) AS c,' +
                " strftime('%Y', p.play_date, 'unixepoch') AS d" +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                sqlCount +
                " GROUP BY strftime('%Y', p.play_date, 'unixepoch')"
            )

            values = []

            var firstYear = new Date(owner.get_date_play_first() * 1000).getUTCFullYear()
            var lastYear = new Date(Util.time() * 1000).getUTCFullYear()

            for (i = firstYear; i <= lastYear; i++) {
                values.push(i - firstYear)
            }

            for (i = 0; i < raw.length; i++) {
                values[parseInt(raw[i].d, 10) - firstYear] = parseInt(raw[i].c, 10)
            }

        }

        return {
            calendar: values
        }

    }
})
